import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext.tsx';

export const useAudienceExcelGenerate = () => {
  const { useDealPromptAudienceExcelGenerate } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceExcelGenerate } = useDealPromptAudienceExcelGenerate();

  return fetchDealPromptAudienceExcelGenerate;
};
